var _g, _path, _g2, _rect, _rect2, _path2, _g3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearches(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8224_3536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1037 7.59671C16.4661 7.21569 16.969 7 17.4948 7H28.81C29.8704 7 30.73 7.85961 30.73 8.92V37.8571C30.73 38.9175 29.8704 39.7771 28.81 39.7771H10.92C9.85962 39.7771 9 38.9175 9 37.8571V15.832C9 15.3394 9.18934 14.8657 9.52885 14.5087L16.1037 7.59671Z",
    fill: "url(#paint0_linear_8224_3536)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8224_3536",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 7,
    width: 22,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1037 7.59671C16.4661 7.21569 16.969 7 17.4948 7H28.81C29.8704 7 30.73 7.85961 30.73 8.92V37.8571C30.73 38.9175 29.8704 39.7771 28.81 39.7771H10.92C9.85962 39.7771 9 38.9175 9 37.8571V15.832C9 15.3394 9.18934 14.8657 9.52885 14.5087L16.1037 7.59671Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8224_3536)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8224_3536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6694 7V15.027H9L16.6694 7Z",
    fill: "#32CDE5"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 21.3555,
    y: 20.7305,
    width: 8.09549,
    height: 1.3288,
    rx: 0.6644,
    transform: "rotate(-180 21.3555 20.7305)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 26.8945,
    y: 24.7178,
    width: 13.6345,
    height: 1.3288,
    rx: 0.6644,
    transform: "rotate(-180 26.8945 24.7178)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8224_3536",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 12,
    width: 44,
    height: 47
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5391 35.3329C18.5391 47.9124 28.268 58.1102 40.2691 58.1102C52.2701 58.1102 61.9991 47.9124 61.9991 35.3329C61.9991 22.7535 52.2701 12.5557 40.2691 12.5557C28.268 12.5557 18.5391 22.7535 18.5391 35.3329Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8224_3536)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8224_3536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8127 8.70804C20.1751 8.32702 20.6779 8.11133 21.2038 8.11133H32.519C33.5794 8.11133 34.439 8.97094 34.439 10.0313V38.9684C34.439 40.0288 33.5794 40.8884 32.519 40.8884H14.629C13.5686 40.8884 12.709 40.0288 12.709 38.9684V16.9434C12.709 16.4508 12.8983 15.977 13.2378 15.6201L19.8127 8.70804Z",
    fill: "url(#paint1_linear_8224_3536)"
  })), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 29.1387,
    y: 24.7773,
    width: 16.43,
    height: 1.66663,
    rx: 0.833315,
    transform: "rotate(-180 29.1387 24.7773)",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_8224_3536)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 32.74C17 44.1943 26.2857 53.48 37.74 53.48C49.1943 53.48 58.48 44.1943 58.48 32.74C58.48 21.2857 49.1943 12 37.74 12C26.2857 12 17 21.2857 17 32.74Z",
    stroke: "#0C9CB2",
    strokeWidth: 4.8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_8224_3536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4238 49.0547L62.7393 60.9155",
    stroke: "#0C9CB2",
    strokeWidth: 4.8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8224_3536",
    x: 0,
    y: 0,
    width: 39.7305,
    height: 50.7773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262313 0 0 0 0 0.262313 0 0 0 0 0.262313 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8224_3536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8224_3536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8224_3536",
    x: 3,
    y: 3,
    width: 19.6699,
    height: 20.0273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0928159 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8224_3536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8224_3536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8224_3536",
    x: 3.70898,
    y: 1.11133,
    width: 39.7305,
    height: 50.7773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262313 0 0 0 0 0.262313 0 0 0 0 0.262313 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8224_3536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8224_3536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_8224_3536",
    x: 13.5996,
    y: 9.59961,
    width: 52.2812,
    height: 60.2803,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8224_3536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8224_3536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_8224_3536",
    x: 48.0234,
    y: 46.6543,
    width: 22.1152,
    height: 30.6611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8224_3536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8224_3536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8224_3536",
    x1: 3.6999,
    y1: 19.1915,
    x2: 28.9898,
    y2: 41.7297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C9CB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8224_3536",
    x1: 7.40889,
    y1: 20.3029,
    x2: 32.6988,
    y2: 42.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C9CB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E2EB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearches);
export default __webpack_public_path__ + "static/media/searches.a5683c20038647359dc0cd206b3c28ff.svg";
export { ForwardRef as ReactComponent };